import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=6ccdaf42&scoped=true&"
import script from "./Switcher.vue?vue&type=script&lang=ts&"
export * from "./Switcher.vue?vue&type=script&lang=ts&"
import style0 from "./Switcher.vue?vue&type=style&index=0&id=6ccdaf42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccdaf42",
  null
  
)

export default component.exports